import api from '@/api/index.js'

const account_emv_taps = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_EMV_TAPS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_EMV_TAPS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_ACCOUNT_EMV_TAPS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    LoadAccountEmvTaps({commit}, id) {
      commit('SET_ACCOUNT_EMV_TAPS_LOADING', true)
      return api.get(`accounts/${id}/emv-taps?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_EMV_TAPS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_EMV_TAPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_emv_taps
